export default "__VITE_ASSET__CXuz7ruj__"